if (!customElements.get('beauty-purchase-bar')) {
  customElements.define('beauty-purchase-bar', class extends HTMLElement {
    connectedCallback() {
      this.productInfo = this.closest('product-info');
      if (!this.productInfo) return;
      this.button = this.querySelector('button');
      this.price = this.querySelector('.beauty-purchase-bar__price');
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.sync = () => {
        this.source = this.productInfo.querySelector('.product-form__submit');
        if (!this.source) { this.hidden = true; return; }
        const form = this.source.closest('form');
        const recipientFields = form?.querySelector('recipient-form');
        this.needsDetails = Boolean(recipientFields);
        const label = this.source.querySelector('span:not(.loading__spinner)');
        this.button.textContent = this.needsDetails ? this.dataset.optionsLabel || 'View purchase options' : (label?.textContent.trim() || this.source.textContent.trim());
        this.button.disabled = this.source.disabled || this.source.getAttribute('aria-disabled') === 'true';
        this.button.setAttribute('aria-busy', String(this.source.getAttribute('aria-disabled') === 'true'));
        const priceContainer = this.productInfo.querySelector('[id^="price-"] .price');
        const selector = priceContainer?.classList.contains('price--on-sale') ? '.price-item--sale' : '.price__regular .price-item--regular';
        this.price.textContent = priceContainer?.querySelector(selector)?.textContent.trim() || '';
        this.updateVisibility();
      };
      this.updateVisibility = () => {
        const rect = this.source?.getBoundingClientRect();
        this.hidden = !this.mobile.matches || !rect || rect.bottom >= 0;
      };
      this.onPurchase = () => {
        const source = this.productInfo.querySelector('.product-form__submit');
        if (!source || source.disabled || source.getAttribute('aria-disabled') === 'true') return;
        if (this.needsDetails) {
          source.scrollIntoView({ block: 'center', behavior: 'smooth' });
          source.focus({ preventScroll: true });
          return;
        }
        source.click();
      };
      this.button.addEventListener('click', this.onPurchase);
      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.updateVisibility(); });
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.mobile.addEventListener('change', this.updateVisibility);
      this.observer = new MutationObserver(records => {
        if (records.some(record => !this.contains(record.target))) this.sync();
      });
      this.observer.observe(this.productInfo, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      this.mobile?.removeEventListener('change', this.updateVisibility);
      this.button?.removeEventListener('click', this.onPurchase);
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  });
}
